export var VERSION = "1.7.7";